import PropTypes from "prop-types";

import styles from "./styles";

const Item = ({ text, url }) => {
  return (
    <li className={styles.item}>
      <a className={styles.link} href={url}>
        {text || url}
      </a>
    </li>
  );
};

Item.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
};

export default Item;
